// Distribui N filtros numa malha de 12 colunas com no maximo `maxPerRow`
// por linha. As linhas saem equilibradas (7 filtros = 4 + 3, 9 = 3 + 3 + 3,
// 10 = 4 + 3 + 3), nunca uma linha cheia seguida de um filtro sozinho, e cada
// filtro ocupa 12 / (filtros da linha) colunas -- 12, 6, 4 ou 3.
export function balancedSpans(count, maxPerRow = 4) {
  if (!count) return [];
  const rows = Math.ceil(count / maxPerRow);
  const base = Math.floor(count / rows);
  const larger = count % rows; // as primeiras linhas levam um filtro a mais

  const spans = [];
  for (let row = 0; row < rows; row += 1) {
    const size = row < larger ? base + 1 : base;
    for (let i = 0; i < size; i += 1) spans.push(12 / size);
  }
  return spans;
}
